import script from "./ReagendarAulaReposicao.vue?vue&type=script&setup=true&lang=js"
export * from "./ReagendarAulaReposicao.vue?vue&type=script&setup=true&lang=js"

import "./ReagendarAulaReposicao.vue?vue&type=style&index=0&id=164b9cf2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-164b9cf2"]])

export default __exports__